// src/Components/FloorAddModal.jsx
import React, { useEffect, useMemo, useState } from 'react';
import api from '../utils/api';

export default function FloorAddModal({ onClose, onSubmit, locationName }) {
  const [submitting, setSubmitting] = useState(false);
  const [floorName, setFloorName] = useState('1F');
  const [file, setFile] = useState(null);

  const previewUrl = useMemo(() => (file ? URL.createObjectURL(file) : null), [file]);
  useEffect(() => () => previewUrl && URL.revokeObjectURL(previewUrl), [previewUrl]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (submitting) return;

    if (!locationName) { alert('위치가 없습니다.'); return; }
    if (!floorName.trim()) { alert('층 이름을 입력하세요.'); return; }
    if (!file) { alert('도면 이미지를 선택하세요.'); return; }

    // (옵션) 파일 검증
    const MAX_SIZE = 15 * 1024 * 1024;
    if (!file.type.startsWith('image/')) {
      if (!window.confirm('선택한 파일이 이미지가 아닙니다. 계속 진행할까요?')) return;
    }
    if (file.size > MAX_SIZE) {
      alert('파일이 너무 큽니다. 15MB 이하 이미지를 업로드하세요.');
      return;
    }

    const form = new FormData();
    form.append('location', locationName);
    form.append('name', floorName.trim());
    form.append('level', '1');              // ✅ 항상 level=1 고정 전송
    form.append('floorplan', file);

    setSubmitting(true);
    try {
      await api.post('/floors', form);
      alert('✅ 층이 추가되었습니다.');
      onSubmit?.();
      onClose?.();
    } catch (err) {
      console.error('[ADD-FLOOR] 실패:', err);
      alert('❌ 층 추가 실패');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="loc-modal-overlay">
      <div className="loc-modal">
        <h2 className="loc-modal__title">➕ 층 등록</h2>

        <form className="loc-form" onSubmit={handleSubmit}>
          <div className="loc-form-content">
            <div className="pill">{locationName}</div>

            <input
              className="loc-input"
              type="text"
              placeholder='층 이름 (예: "1F","2F","B1")'
              value={floorName}
              onChange={(e) => setFloorName(e.target.value)}
            />

            {/* ✅ level 인풋 제거 (항상 1로 전송) */}

            <input
              className="loc-input loc-file-input"
              type="file"
              accept="image/*"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </div>

          <div className="loc-modal__body">
            {previewUrl ? (
              <div className="loc-preview-panel">
                <img className="loc-preview-img" src={previewUrl} alt="도면 미리보기" />
              </div>
            ) : (
              <div className="loc-preview-panel loc-preview-empty">
                도면 이미지를 선택하면 미리보기가 표시됩니다.
              </div>
            )}
          </div>

          <div className="loc-modal__buttons">
            <button className="loc-btn loc-btn--primary" type="submit" disabled={submitting}>
              {submitting ? '등록 중…' : '등록'}
            </button>
            <button className="loc-btn" type="button" onClick={onClose}>취소</button>
          </div>
        </form>
      </div>
    </div>
  );
}
